export interface OrgOfficialsLike {
  chief_accountant?: string | null;
  chief_accountant_inn?: string | null;
  chief_accountant_signs_reports?: boolean | null;
}

/** ч.1179 (рішення власника): головний бухгалтер потрапляє у підписи
 *  регламентованих звітів (бланки декларацій, повідомлення про прийняття)
 *  лише з галочкою «використовувати в регламентованих звітах» на картці
 *  організації. Без неї — null (підписує лише керівник). */
export function chiefForReports(
  org: OrgOfficialsLike | null | undefined,
): { name: string; inn: string } | null {
  if (!org || !org.chief_accountant_signs_reports) return null;
  const name = (org.chief_accountant ?? '').trim();
  if (!name) return null;
  return { name, inn: (org.chief_accountant_inn ?? '').trim() };
}
